import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  const user = token ? JSON.parse(token) : null;
  // console.log(token);
  // console.log(user);
  
  if (user && user.username === 'tushitasingh' && user.password === 'bdc12345') {
    console.log('User is logged in');
    
    return children;
  }

  return <Navigate to="/admin/login" />;
};

export default ProtectedRoute;